export default __webpack_public_path__ + "static/img/Company_2.89f1320.jpg";